import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/icons/icons-iw/icon-teaser-magnify.svg'
import _imports_1 from '../assets/images/icons/icons-iw/icon-teaser-arrows.svg'


const _hoisted_1 = { class: "signin-container" }
const _hoisted_2 = { class: "signin-primarySection" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "signin-secondarySection" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "signin-infoWrap signin-infoWrap--default" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "signin-infoContentWrap" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "signin-infoBlur" }),
      /*#__PURE__*/_createElementVNode("div", { class: "signin-infoContent" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "signin-headerWrap" }, [
          /*#__PURE__*/_createElementVNode("h1", null, [
            /*#__PURE__*/_createElementVNode("b", null, "Willkommen zurück!"),
            /*#__PURE__*/_createTextVNode(" Jetzt anmelden und gespeicherte Inhalte und Apps nutzen. ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "signin-benefitWrap" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "signin-benefit" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "signin-benefitIconWrap" }, [
              /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "signin-benefitText" }, [
              /*#__PURE__*/_createElementVNode("div", null, "Effiziente Suche mit Suchauftrag und weiteren Services")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "signin-benefit" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "signin-benefitIconWrap" }, [
              /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "signin-benefitText" }, [
              /*#__PURE__*/_createElementVNode("div", null, "Einfache Anzeigenerstellung und -bearbeitung")
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_navigation_ui_footer = _resolveComponent("navigation-ui-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingOverlay),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_navigation_ui_footer, { style: {"display":"block"} })
    ]),
    _hoisted_3
  ]))
}